"use client";

import { FC } from "react";
import { AssetsDirectory } from "@finbackoffice/enums";
import AccountHeader from "../../header/AccountHeader";
import SelfExclusion from "./SelfExclusion";
import DepositLimits from "./DepositLimits";
import styles from "./responsible-gaming.module.sass";

type IProps = {
    showHeader?: boolean;
};

const ResponsibleGaming: FC<IProps> = ({ showHeader = true }) => {
    return (
        <>
            <div className={styles.responsibleGaming} data-testid="responsible-gaming-container">
                {showHeader && (
                    <AccountHeader
                        headingIcon={`/${AssetsDirectory.Mobile}/${AssetsDirectory.ProfileCompact}/profile-responsible-gaming.svg`}
                        tId="account_details_responsibleGaming_heading"
                        className={styles.compactHeader}
                    />
                )}
                <DepositLimits />
                <SelfExclusion />
            </div>
        </>
    );
};

export default ResponsibleGaming;
